import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { Vehicle } from '@commons/models/domain/Vehicle';

@Component({
  selector: 'app-vehicle-change-name-form',
  standalone: true,
  imports: [InputTextModule, CommonModule, FormsModule, FloatLabelModule, ButtonModule, TranslateModule],
  templateUrl: './vehicle-change-name-form.component.html',
  styleUrls: ['./vehicle-change-name-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleChangeNameFormComponent implements OnInit {
  private readonly config: DynamicDialogConfig<Vehicle> = inject(DynamicDialogConfig);
  private readonly ref: DynamicDialogRef = inject(DynamicDialogRef);

  public vehicleName?: string = '';

  constructor(private changeDetRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.vehicleName = this.config.data?.Nm;
    this.changeDetRef.detectChanges();
  }

  public submit(): void {
    if (this.vehicleName?.length) {
      const isChanged = this.config.data?.Nm !== this.vehicleName;
      this.ref.close(isChanged ? this.vehicleName : false);
    }
  }

  public cancel(): void {
    this.ref.close();
  }

}
